import Parse from "parse";

export const addNewIncharge = async (data) => {
    return Parse.Cloud.run("addNewIncharge", data);
}